import $http from '$http';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';
export default {
    methods: {
        // 新增代理区域
        addAgentAreaToServer() {
            let agentData = this.$refs['addAgentInfo1'][0].validate();
            if (!agentData) {
                return;
            }
            let params = Object.assign({}, util.getSidAndSession, {
                AgentId: this.AgentId
            }, agentData);
            this.submitBtn = true;
            //POST /api/Agent/AddAgentArea
            $http.post('api/Agent/AddAgentAreaEx', params).then(res => {
                this.submitBtn = false;
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '添加成功！',
                        type: 'success'
                    });
                    this.addVisible = false;
                    this.req_getAreaList();
                });
            });
        },
        req_getAreaList() {
            let params = {
                Sid: this.sysSid,
                Session: this.sysSession,
                AgentId: this.AgentId
            };
            $http.get("api/Agent/GetAgentAreasByAgentId", params).then(res => {
                let {
                    Data
                } = res.data;
                util.doResult(this, res, () => {
                    this.$nextTick(() => {
                        this.AreaList = Data;
                    });
                });
            });
        },
        req_getOneData(Id, AgentAreaId) {
            let params = {
                Sid: this.sysSid,
                Session: this.sysSession,
                Id: AgentAreaId
            };
            this.agentAreaId = AgentAreaId;
            $http.get("api/AgentAreas/GetById", params).then(res => {
                let {
                    Data
                } = res.data;
                util.doResult(this, res, () => {
                    this.editData = Data;
                    // this.CustomerId = this.editData.CustomerId;
                    this.agentList = Data.List
                    this.isPerson = false
                    this.editVisible = true;
                });
            });
        },
        getHtList() {
            let params = {
                Sid: this.sysSid,
                Session: this.sysSession,
                AgentId: this.AgentId
            };

            $http.get("/api/Agent/GetContractListByAgentId", params).then(res => {
                let {
                    Data
                } = res.data;
                util.doResult(this, res, () => {
                    this.$nextTick(() => {
                        this.htztList = Data;
                    });
                });
            });
        },
        // 修改代理商区域POST /api/AgentAreas/UpdateAgentArea
        updateAgentArea() {
            let dataArea = false
            let form = {
                Id: '',
                List: [],
                IsUpdateContactOrCustomer: 0,
                CustomerId: this.CustomerId,
                ForceModify: 1
            }
            for (let i = 0; i < this.agentList.length; i++) {
                dataArea = this.$refs['agentInfo' + (i + 1)][0].validate();
                form.List.push(dataArea);
            }
            if (!dataArea) {
                return;
            }
            form.List[0].Id = this.agentAreaId
            form.Id = this.AgentId
            // let params = Object.assign({}, util.getSidAndSession, {
            //     Id: this.agentAreaId,
            //     AgentId: this.AgentId
            // }, agentData);
            this.submitBtn = true;
            $http.post('api/AgentAreas/UpdateAgentArea', form).then(res => {
                this.submitBtn = false;
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '修改成功！',
                        type: 'success'
                    });
                    this.editVisible = false;
                    this.req_getAreaList();
                });
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/CRMAgentManage/CRMFormatAgent/components/agentArea/services.js